<template>
	<div class="m-t-20">
    <div class="ovf-hd">
      <div class="fl">列表配置</div>
      <div class="fl m-l-20">
        <el-button size="small" type="primary" @click="addCol()">添加列</el-button>
        <el-button size="small" type="primary" @click="showImport" v-if="hasImport">批量导入</el-button>
        <el-button class="m-l-10" size="small" type="primary" @click="setSortConfig()" v-if="!isSimple">展示数据配置</el-button>
        <slot></slot>
      </div>
    </div>
    <div class="m-t-10 table-container">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        :row-class-name="tableRowClassName">
        <el-table-column
          prop="show_name"
          label="列名称"
          width="150">
        </el-table-column>
        <el-table-column
          label="字段名"
          width="150">
          <template scope="scope">
            {{ getFieldName(scope.row.field_id) }}
          </template>
        </el-table-column>
        <el-table-column
          label="权限"
          v-if="!isSimple">
          <template scope="scope">
            <span>{{ scope.row.rule.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="250">
          <template scope="scope">
            <el-button size="mini" @click="setConfig(scope.$index, scope.row)">配置</el-button>
            <el-button v-if="scope.$index != 0" size="mini" @click="moveTr(scope.$index, 0)">上移</el-button>
            <el-button v-if="scope.$index != tableData.length - 1" size="mini" @click="moveTr(scope.$index, 1)">下移</el-button>
            <el-button size="mini" @click="deleteCol(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<style>
.el-table .row-focus {
  background: rgba(255, 102, 102, .2)
}
</style>
<script>
export default {
  name: 'listTable',
  props: {
    showType: {
      type: String,
      default() {
        return ''
      }
    },
    focusIndex: {
      type: Number,
      default() {
        return -1
      }
    },
    tableData: {
      type: Array,
      default() {
        return []
      }
    },
    listIndex: {
      type: Number,
      default() {
        return -1
      }
    },
    fields: {
      type: Array,
      default() {
        return []
      }
    },
    isSimple: { // 简化版
      type: Boolean,
      default() {
        return false
      }
    },
    hasImport: { // 是否有批量导入功能
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      focusRow: -1,
      tableObj: {
        show_name: '',
        deal_type: 0,
        // field_name: '',
        field_id: null,         // 字段id
        field_type: null,       // 字段类型（控件类型，具体怎么用我都唔鸠知，问彬仔）
        is_exit: 1,             // 是否数据表字段
        is_visible: 1,          // 是否渲染可见
        rule: {
          id: '',
          name: ''
        },
        arithmetic: '',
        is_jump: 0,
        is_down: 0,
        is_sort: 0,
        group_name: '',
        // param: '',
        // reality: {
        //   id: null,
        //   name: ''
        // },
        width: '',                  // 宽度
        is_summary: 0,              // 是否汇总: 1 -- 是；0 -- 否
        is_statistics: 0,           // 是否统计: 1 -- 是; 0 -- 否
        is_php: 0,                  // 是否统计: 1 -- 是; 0 -- 否
        summaryConfig: {
          table_id: null,           // 关联数据表id
          field_option: [],         // 字段选项
          foreign_option: [],       // 外键字段选项
          relate_field_id: '',      // 关联字段
          summary_field_id: '',     // 汇总字段
          summary_condition: [],    // 汇总条件
          marjor_field_id: ''       // 本表字段
        },
        statistics_configs: {
          table_id: null,           // 关联数据表id
          field_option: [],         // 字段选项
          foreign_option: [],       // 外键字段选项
          relate_field_id: '',      // 关联字段
          statistics_field_id: '',  // 统计字段
          statistics_condition: [], // 统计条件
          marjor_field_id: '',     // 本表字段
          statistics_method: ''    // 统计方法
        },
        key_config: [],             // 外键配置
        // fields: [],                 // 所有字段
        // field_option: [],           // 选择后的字段
        link_option: [],             // 链接配置
        download_link: ''           // 下载链接
      }
    }
  },
  methods: {
    sendColObj() {
      let newTableObj = _.cloneDeep(this.tableObj)
      return newTableObj
    },
    addCol() {
      let newTableObj = _.cloneDeep(this.tableObj)
      this.$emit('addCol', this.listIndex, newTableObj)
    },
    deleteCol(index) {
      this.$emit('deleteCol', this.listIndex, index)
    },
    moveTr(index_, type) {
      let arr = []
      if (type) {
        // 下移
        arr = this.exchangePosition(this.tableData, index_, index_ + 1)
        this.setConfig(index_ + 1)
      } else {
        // 上移
        arr = this.exchangePosition(this.tableData, index_, index_ - 1)
        this.setConfig(index_ - 1)
      }
      this.tableData = arr
    },
    exchangePosition(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    setConfig(index, item) {
      this.focusRow = index
      this.$emit('setColConfig', this.listIndex, index)
    },
    setSortConfig(index) {
      this.$emit('setSortConfig', this.listIndex, index)
    },
    tableRowClassName(row, index) {
      let className = ''
      if (this.showType == 'col' && this.focusIndex == this.listIndex && this.focusRow == index) {
        className = 'row-focus'
      }
      return className
    },
    getFieldName(id) {
      let name = ''
      _(this.fields).forEach((res) => {
        if (res.field_id == id) {
          name = res.field
          return false
        }
      })
      return name
    },
    showImport() {
      this.$emit('showImport', true)
    }
  }
}
</script>


// WEBPACK FOOTER //
// listTable.vue?22e4c45e